import BaseAPIService from '@/services/baseAPIService'

export default class OrderEditorAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  getOrderEditorShapePriceTypeList()        { return this.httpClient.get(`/ordereditor/shapepricetypes`) }
  getOrderEditorShapePriceType(id)          { return this.httpClient.get(`/ordereditor/shapepricetypes/${id}`) }
  createOrderEditorShapePriceType(data)     { return this.httpClient.post(`/ordereditor/shapepricetypes`, data) }
  updateOrderEditorShapePriceType(id, data) { return this.httpClient.put(`/ordereditor/shapepricetypes/${id}`, data) }

  getOrderEditorCutout(id)          { return this.httpClient.get(`/ordereditor/cutouts/${id}`) }
  createOrderEditorCutout(data)     { return this.httpClient.post(`/ordereditor/cutouts`, data) }
  updateOrderEditorCutout(id, data) { return this.httpClient.put(`/ordereditor/cutouts/${id}`, data) }
  deleteOrderEditorCutout(id)       { return this.httpClient.delete(`/ordereditor/cutouts/${id}`) }

  getOrderEditorEdgeworkList(options = {}, filter = {}) {
    var params = {
      filter: filter || {},
      include: options.include
    }
    var queryString = '/ordereditor/edgeworks?' + $.param(params)
    return this.httpClient.get(queryString)
  }
  getOrderEditorEdgework(id)          { return this.httpClient.get(`/ordereditor/edgeworks/${id}`) }
  createOrderEditorEdgework(data)     { return this.httpClient.post(`/ordereditor/edgeworks`, data) }
  updateOrderEditorEdgework(id, data) { return this.httpClient.put(`/ordereditor/edgeworks/${id}`, data) }

  getOrderEditorDefaultEdgeworkList()         { return this.httpClient.get(`/ordereditor/defaultedgeworks`) }
  updateOrderEditorDefaultEdgeworkList(data)  { return this.httpClient.put(`/ordereditor/defaultedgeworks`, data) }

  getStockOrderEditorDefaultEdgeworkList(stockId)           { return this.httpClient.get(`/ordereditor/stock/${stockId}/defaultedgeworks`) }
  updateStockOrderEditorDefaultEdgeworkList(stockId, data)  { return this.httpClient.put(`/ordereditor/stock/${stockId}/defaultedgeworks`, data) }

  getStockOrderEditorEdgeworkAllowanceList(stockId)           { return this.httpClient.get(`/ordereditor/stock/${stockId}/edgeworkallowances`) }
  updateStockOrderEditorEdgeworkAllowanceList(stockId, data)  { return this.httpClient.put(`/ordereditor/stock/${stockId}/edgeworkallowances`, data) }

  getOrderEditorGuidelines()                                { return this.httpClient.get(`/ordereditor/guidelines`) }
  updateOrderEditorGuidelines(data)                         { return this.httpClient.put(`/ordereditor/guidelines`, data) }

  getConfigSettings()               { return this.httpClient.get(`/ordereditor/settings`) }
  updateConfigSettings(data)        { return this.httpClient.put(`/ordereditor/settings`, data) }
  
}